<template>
    <custom-widget-form
        :title="$t('custom_widgets.create_custom_widget')"
        :id-site="idSite"
        :save="save"
    ></custom-widget-form>
</template>

<style scoped lang="scss"></style>
<script>
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import CustomWidgetForm from '@/vue/components/shared/custom-widgets/CustomWidgetForm';
import { ngInject } from '@/vue/decorators/angular-interop';

@Component({
    components: { CustomWidgetForm },
})
export default class CreateCustomWidgetForm extends Vue {
    @Prop()
    idSite;

    @ngInject()
    ApiService;

    async save(payload) {
        return this.ApiService.call2(`/installations/${this.idSite}/custom-widget`, payload, {
            method: 'POST',
        });
    }
}
</script>
